jQuery($ => {
    const toBlur = $('header, main, footer, body, .m-mobile-nav');
    const popupOpen = $(".popupOpen");
    const popupWrap = $(".m-popup");
    const popupClose = $(".m-popup__close");
    const popupChidren = $(".m-popup__single");
    const loginPopup = $(".loginPopup");
    const registerPopup = $(".registerPopup");
    const jobofferPopup = $(".jobofferPopup");
    const smalloffersPopup = $(".smalloffersPopup");
    const forgotPassPopup = $(".forgotPassPopup");
    const workPopup = $(".workofferPopup");
    const acfTitle = $("#acf-_post_title");

    // variables for event
    const eventPopup = $('.eventPopup');
    const eventCancel = $("#eventCancel");

    const resetPassPopup = $("#resetPassPopup");

    acfTitle.attr("placeholder", "Tytuł");

    $(window).on("load", function() {
        $('.mce-i-blockquote, .mce-i-strikethrough, .mce-i-alignleft, .mce-i-aligncenter, .mce-i-alignright, .mce-i-undo, .mce-i-redo, .mce-i-link, .mce-i-fullscreen').parent().parent().remove();
    });

    function showPopup(e) {
        popupWrap.addClass('active');
        toBlur.addClass('blur');
        $('html, body').addClass('blocked');

        // TODO: zmienić na coś w stylu [data-id]. Początkowo były dwa popupy i miało sens aktualne rozwiązanie,
        if (e.hasClass("loginBtn")) {
            popupChidren.hide();
            loginPopup.show();
        } else if (e.hasClass("registerBtn")) {
            popupChidren.hide();
            registerPopup.show();
        } else if (e.hasClass("smalloffersBtn")) {
            popupChidren.hide();
            smalloffersPopup.show();
        } else if (e.hasClass("workBtn")) {
            popupChidren.hide();
            workPopup.show();
        } else if (e.hasClass("jobsBtn")) {
            popupChidren.hide();
            jobofferPopup.show();
        } else if (e.hasClass("forgotPassBtn")) {
            popupChidren.hide();
            forgotPassPopup.show();
        } else if (e.hasClass("eventBtn")) {
            popupChidren.hide();
            eventPopup.show();
        }


    }

    function showResetPass(e) {
        if (resetPassPopup.hasClass("resetOpen")) {
            popupWrap.addClass("active");
            toBlur.addClass("blur");
            $("html, body").addClass("blocked");
        }
    }
    showResetPass();

    function hidePopup(e) {
        popupWrap.removeClass('active');
        toBlur.removeClass('blur');
        loginPopup.hide();
        registerPopup.hide();
        if (! $('.m-mobile-nav').hasClass('active')) {
            $("html, body").removeClass("blocked");
        }
    }

    popupOpen.on('click', function(e) {
        showPopup($(this));
        e.preventDefault();
    });

    popupClose.on('click', function (e) {
        hidePopup();
    });

    eventCancel.on('click', function(e) {
        e.preventDefault();
        hidePopup();
    });

    if(typeof acf !== 'undefined') {

        acf.add_filter('validation_complete', function( json, $form ){
        
            // if errors?
            if( json.errors ) {
                setTimeout(function() {
                    console.log($('.acf-error').first().offset().top);
                    $(".m-popup").animate({ scrollTop: 0}, 600);
                }, 100);
            }
            
            // return
            return json;
                    
        });
    }
});
